query ReadBimClassName(
    $id: ID!
) {
    bimClass(
        id: $id
        tag: "latest"
    ) {
        id
        revisionID

        data {
            name(language: "en") {
                text
            }
        }
    }
}
